module.exports = __webpack_public_path__ + "static/step2-be2bb8e27ff91bcd6c673f62c3ed99aa.png";